export default __webpack_public_path__ + "static/23-e2a4f11b546a5c6754d4b27af1355bdc.webp";